import Premium from "./Premium";

export default Premium;
